import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { GlobalPolicyConflictsPageExtraProps } from './RemediationPage.entrypoint.types.tsx';

type GlobalPolicyConflictsPageEntryPointComponent = EntryPointComponent<
	{},
	{},
	{},
	GlobalPolicyConflictsPageExtraProps
>;

export const globalPolicyConflictsPageEntryPoint: EntryPoint<
	GlobalPolicyConflictsPageEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<GlobalPolicyConflictsPageEntryPointComponent>(
		/* webpackChunkName: "async-guided-autonomy-remediation-global" */ './GlobalPolicyConflictsPage.tsx',
	),
	getPreloadProps: ({ context: { match }, tenantContext }: EntryPointRouteParams) => ({
		extraProps: {
			kind: 'global' as const,
			policyId: match.params.policyId ?? undefined,
			isAdmin: tenantContext.isAdmin,
		},
	}),
});
